import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { AssessmentDetailProvider } from './context/AssessmentDetailProvider'
import { AssessmentDetailMain } from './AssessmentDetailMain'

export const AssessmentDetail = () => {
  const { positionId, userId } = useParams()

  if (
    !positionId ||
    isNaN(Number(positionId)) ||
    !userId ||
    isNaN(Number(userId))
  ) {
    return <Navigate to="/not-found" />
  }

  return (
    <AssessmentDetailProvider
      positionId={Number(positionId)}
      userId={Number(userId)}
    >
      <AssessmentDetailMain />
    </AssessmentDetailProvider>
  )
}
